import type { RouteType } from '../../types/route-type';
import { ROCK_TINT, ROUTE_TYPE_GLYPHS } from './route-type-glyphs';

/** The pictogram of a route's type. Decorative: its label is always beside it. */
export function RouteTypeIcon({ type, className }: { type: RouteType; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {ROUTE_TYPE_GLYPHS[type].map(({ d, fill }) => (
        <path
          key={d}
          d={d}
          fill={fill ? 'currentColor' : undefined}
          fillOpacity={fill === 'rock' ? ROCK_TINT : undefined}
          stroke={fill === 'solid' ? 'none' : undefined}
        />
      ))}
    </svg>
  );
}
